import React, { useEffect } from "react"
import { useHistory } from "react-router-dom"
import userStore from "userStore"

import { deleteToken } from "helpers/auth_helpers"
import toastHandler from "toastHandler"

const Logout = () => {
  const history = useHistory()

  const changes = userStore(state => state.changes)
  const reset = userStore(state => state.reset)
  const cleanError = toastHandler(state => state.cleanError)

  const logoutUser = () => {
    deleteToken()
    cleanError()
    localStorage.clear()
    history.push("/iniciar-sesion")
  }

  useEffect(() => {
    if (!changes) {
      logoutUser()
      reset()
    }
  }, [changes])

  return <></>
}

export default Logout
